import OpValueRange from "./index.vue";
var opvaluerange = {
  install: function install(Vue) {
    Vue.component("OpValueRange", OpValueRange);
  }
};
export default opvaluerange;